/**
 * Created by - Ashish Dewangan on 08-07-2024
 * Reason - Created a page where content will change when we change the route
 */

import basePageStyle from "./BasePage.module.css";
import { useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Home from "../Home/Home";
// import Login from "../Login/Login";
// import Signup from "../Signup/Signup";
import Events from "../Events/Events";
import RequestCallback from "../RequestCallback/RequestCallback";
import Blog from "../Blog/Blog";
import BlogDetailed from "../Blog/BlogDetailed";
import Gallery from "../Gallery/Gallery";
import ContactUs from "../ContactUs/ContactUs";
import Certificates from "../Certificates/Certificates";
import PrivacyPolicy from "../PrivacyPolicy/PrivacyPolicy";
import TermsAndConditions from "../TermsAndConditions/TermsAndConditions";
// import RequestCallbackButton from "../../components/Buttons/RequestCallbackButton/RequestCallbackButton";
import SocialIcons from "../../components/SocialIcons/SocialIcons";
import PopupEvent from "../Events/PopupEvent";
import { useEffect } from "react";
import Matrimony from "../Matrimony/Matrimony";
import MatrimonialProfileDetail from "../Matrimony/MatrimonialProfileDetail";
import MatrimonialRegistrationForm from "../Matrimony/MatrimonialRegistrationForm";
import Member from "../Member/Member";
import Career from "../Career/Career";
import School from "../School/School";
import MemberDetailWardWise from "../Member/MemberDetailWardWise";
import AboutUs from "../AboutUs/AboutUs";
import LifeMemberDeatails from "../Member/LifeMemberDeatails";

const BasePage = () => {
  const location = useLocation();
  const [currentPath, setCurrentPath] = useState("");

  useEffect(() => {
    setCurrentPath(location.pathname);
  }, [location.pathname]);

  return (
    <div
      className={`${basePageStyle.pageFrame}`}
      style={currentPath.endsWith("/") ? { backgroundImage: "none" } : {}}>
      <div className={`${basePageStyle.pageContainer}`}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/events" element={<Events />} />
          <Route path="/news" element={<Blog />} />
          <Route path="/news_detailed" element={<BlogDetailed />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/certificates" element={<Certificates />} />
          <Route path="/request-callback" element={<RequestCallback />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route path="/event" element={<PopupEvent />} />
          <Route path="/matrimony" element={<Matrimony />} />
          {/* Added by - Ashlekh on 03-04-2025
          Reason - To add matrimony detailed page */}
          <Route path="/matrimonial-profile" element={<MatrimonialProfileDetail />} />
          {/* End of code - Ashlekh on 03-04-2025
          Reason - To add matrimony detailed page */}
          {/* Added by - Ashlekh on 04-04-2025
          Reason - To add matrimonial registration form */}
          <Route path="/matrimony_registration_form" element={<MatrimonialRegistrationForm />} />
          {/* End of code - Ashlekh on 04-04-2025
          Reason - To add matrimonial registration form */}
          {/* Added by - Ashlekh on 08-04-2025
          Reason - To add member page */}
          <Route path="/members" element={<Member />} />
          {/* End of code - Ashlekh on 08-04-2025
          Reason - To add member page */}
          {/* Added by - Ashlekh on 21-04-2025
          Reason - To add career page */}
          <Route path="/career" element={<Career />} />
          {/* End of code - Ashlekh on 21-04-2025
          Reason - To add career page */}
          {/* Added by - Ashlekh on 24-04-2025
          Reason - To add School page */}
          <Route path="/school" element={<School />} />
          {/* End of code - Ashlekh on 24-04-2025
          Reason - To add School page */}
          {/* Added by - Ashlekh on 24-04-2025
          Reason - To add MemberDetailWardWise page */}
          <Route path="/member_list" element={<MemberDetailWardWise />} />
          <Route path="/about_us" element={<AboutUs />} />
          {/* End of code - Ashlekh on 24-04-2025
          Reason - To add MemberDetailWardWise page */}
          {/* Added by - Yogen on 14-06-2025
          Reason - To add LifeMemberDetails page */}
          <Route path="/life_member_list" element={<LifeMemberDeatails />} />
          {/* End of code - Yogen on 14-06-2025
          Reason - To add LifeMemberDetails page */}
        </Routes>
      </div>
      <RequestCallback />
      <SocialIcons />
    </div>
  );
};

export default BasePage;
